import React, { FC } from 'react';

import { Control, Controller } from 'react-hook-form';

import { Autocomplete, Box, GridLegacy as Grid, TextField } from '@mui/material';

interface DepartmentTagSelectorProps {
  promoTagArrays: App.PromoTagArrays | null;
  promoTagSelections: {
    selectedDepartment: string | null;
    selectedCategory: string | null;
    selectedSubCategory: string | null;
  };
  setPromoTagSelection: (
    deptTag: string,
    categoryTag?: string,
    subCategoryTag?: string,
  ) => {
    selectedDepartment: string | null;
    selectedCategory: string | null;
    selectedSubCategory: string | null;
  };
  isPromoMetaLoading: boolean;

  // Form-specific props
  formType: 'react-hook-form' | 'rjsf';
  // React Hook Form props
  control?: Control<any>;
  // RJSF props
  formData?: any;
  onFormChange?: (evt: any) => void;
  // Custom input props
  allowCustomInput?: boolean;
  isErroring?: boolean;
}

const DepartmentTagSelector: FC<DepartmentTagSelectorProps> = ({
  promoTagArrays,
  promoTagSelections,
  setPromoTagSelection,
  isPromoMetaLoading,
  formType,
  control,
  formData,
  onFormChange,
  allowCustomInput = false,
  isErroring = false,
}) => {
  if (isPromoMetaLoading || promoTagArrays == null || promoTagArrays.departmentTags.length === 0) {
    return null;
  }

  const handleChange = (newValue: string | null) => {
    if (formType === 'rjsf' && onFormChange && formData) {
      const updatedFormData = {
        ...formData,
        dept_tag: newValue,
      };

      onFormChange({
        formData: updatedFormData,
      });
    }

    setPromoTagSelection(newValue, promoTagSelections.selectedCategory);
  };

  if (formType === 'react-hook-form' && control) {
    return (
      <Controller
        key="dept_tag"
        name="dept_tag"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <Box sx={{ width: '100%' }}>
            <Autocomplete
              {...field}
              value={promoTagSelections.selectedDepartment || ''}
              options={promoTagArrays.departmentTags}
              freeSolo={allowCustomInput}
              renderInput={(params) => (
                <TextField
                  name="dept_tag"
                  required
                  fullWidth
                  {...params}
                  variant="outlined"
                  label="Department"
                  helperText={allowCustomInput ? 'Type to search or enter custom value' : undefined}
                  error={isErroring}
                />
              )}
              onChange={(e: unknown, newValue: string | null) => {
                field.onChange(newValue);
                handleChange(newValue);
              }}
            />
          </Box>
        )}
      />
    );
  }

  return (
    <Grid item xs={4}>
      <Autocomplete
        value={promoTagSelections.selectedDepartment || ''}
        options={promoTagArrays.departmentTags}
        freeSolo={allowCustomInput}
        renderInput={(params) => (
          <TextField
            name="dept_tag"
            required
            {...params}
            variant="outlined"
            label="Department"
            helperText={allowCustomInput ? 'Type to search or enter custom value' : undefined}
            error={isErroring}
          />
        )}
        onChange={(e: unknown, newValue: string | null) => {
          handleChange(newValue);
        }}
      />
    </Grid>
  );
};

export default DepartmentTagSelector;
